import React from 'react';
import { Panel, PanelTitle } from '@prisjakt/ui/panel';
import { FeaturedArticle } from '../../components/featured-article';
import { useAppContext } from 'src/components/app-context';
import * as S from './styles';
import type { Article } from 'src/types';

export const CategoryArticles: React.FC<CategoryArticlesProps> = ({
  articles,
}) => {
  const { t } = useAppContext();

  const featuredArticle = articles
    ? articles.find(item => item.featured)
    : null;
  if (!featuredArticle) {
    return null;
  }
  return (
    <S.CategoryPageGutter>
      <Panel>
        <PanelTitle>{t('category', 'article.related-articles')}</PanelTitle>
        <FeaturedArticle article={featuredArticle} related={articles} />
      </Panel>
    </S.CategoryPageGutter>
  );
};

interface CategoryArticlesProps {
  articles: Article[];
}
